import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

interface NoResultsEventProps {
  sourcePage: SourcePages;
}

export function NoResultsEvent({ sourcePage }: NoResultsEventProps): EventData {
  return {
    event_type: EventType.view,
    source_page: sourcePage,
    feature: Features.noVehiclesFound,
    event_context: {},
    view_type: 'feature_view',
  };
}
